import logo from "../../asset/images/svgs/logo.svg"
import React from "react";

export default function Logo(){
    return(
        <>
            <div>
                <a className={"d-flex align-items-center"} href="/">    
                    <img src={logo} alt="Frontend developer"/>
                    <h3 className={"logo_title mb-0 pb-0 ps-3 text-white"}>Brijesh</h3>
                </a>
            </div>
        </>
    )
};